// Author Lin
// Date 2021-10-22 16:41:01

import * as model from "@/model/mintalMes/prd/MintalMesPrdPelletizingGrindingParameterModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdPelletizingGrindingParameter(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
